{
 "id": "okubo-east",
 "light": 0.6,
 "_note": "Okubo east (Koreatown-ish residential-commercial strip): apartment blocks, groceries, laundromats and grill restaurants. Cosmetic only. Props are generated by a packing script; edit freely.",
 "rect": {
  "x": 200,
  "y": 0,
  "w": 56,
  "h": 96
 },
 "buildings": [
  {
   "id": "n1",
   "x": 200,
   "y": 0,
   "w": 12,
   "h": 4,
   "face": 2,
   "kind": "okuboEGrocer",
   "roof": "concrete",
   "props": [
    [
     "ac",
     6.9,
     0.7
    ],
    [
     "ac",
     5.4,
     0.9
    ],
    [
     "dish",
     3.4,
     0.4
    ]
   ]
  },
  {
   "id": "n2",
   "x": 212,
   "y": 0,
   "w": 13,
   "h": 4,
   "face": 2,
   "kind": "okuboELaundry",
   "roof": "okuboEPaint",
   "props": [
    [
     "tank",
     9.4,
     0.4
    ],
    [
     "ac",
     2.2,
     0.8
    ],
    [
     "dish",
     4.7,
     0.6
    ],
    [
     "hut",
     7.5,
     0.4
    ]
   ]
  },
  {
   "id": "n3",
   "x": 225,
   "y": 0,
   "w": 12,
   "h": 4,
   "face": 2,
   "kind": "konbini",
   "roof": "tar",
   "props": [
    [
     "dish",
     4.2,
     0.8
    ],
    [
     "hut",
     8.2,
     0.4
    ],
    [
     "hut",
     5.2,
     0.4
    ]
   ]
  },
  {
   "id": "n4",
   "x": 237,
   "y": 0,
   "w": 13,
   "h": 4,
   "face": 2,
   "kind": "okuboEBbq",
   "roof": "concrete",
   "sign": {
    "text": "チキン",
    "color": "cyan"
   },
   "props": [
    [
     "ac",
     3.2,
     0.7
    ],
    [
     "okuboEJars",
     8.7,
     1
    ],
    [
     "okuboEJars",
     6.1,
     0.7
    ],
    [
     "vent",
     0.8,
     1
    ]
   ]
  },
  {
   "id": "e1",
   "x": 250,
   "y": 0,
   "w": 6,
   "h": 20,
   "face": 0,
   "kind": "okuboEFlats",
   "roof": "okuboEPaint",
   "props": [
    [
     "okuboEWash",
     1.2,
     15.2
    ],
    [
     "ac",
     1.7,
     0.4
    ],
    [
     "okuboEJars",
     1.8,
     17.1
    ],
    [
     "okuboEJars",
     2.7,
     13
    ],
    [
     "vent",
     2.7,
     18.9
    ],
    [
     "tank",
     3.2,
     7.2
    ],
    [
     "ac",
     2.1,
     4.3
    ],
    [
     "okuboEGarden",
     3.8,
     4.5
    ],
    [
     "ac",
     1.2,
     8.6
    ],
    [
     "okuboESolar",
     3.3,
     8.8
    ],
    [
     "ac",
     0.9,
     9.9
    ],
    [
     "vent",
     4.9,
     13.6
    ],
    [
     "ac",
     4.7,
     0.8
    ],
    [
     "ac",
     0.7,
     18.8
    ],
    [
     "vent",
     1.5,
     1.4
    ],
    [
     "ac",
     3.1,
     6
    ],
    [
     "okuboEGarden",
     2.3,
     11.5
    ],
    [
     "okuboESolar",
     3.4,
     3.1
    ],
    [
     "okuboESolar",
     0.4,
     3.9
    ],
    [
     "ac",
     1.1,
     5.8
    ],
    [
     "okuboESolar",
     4.2,
     18.5
    ],
    [
     "okuboEJars",
     3.7,
     15.9
    ]
   ]
  },
  {
   "id": "e2",
   "x": 250,
   "y": 20,
   "w": 6,
   "h": 20,
   "face": 0,
   "kind": "okuboEFlats",
   "roof": "concrete",
   "props": [
    [
     "hut",
     0.5,
     17.1
    ],
    [
     "ac",
     2.9,
     4.4
    ],
    [
     "okuboEJars",
     0.9,
     11.8
    ],
    [
     "okuboEWash",
     1.4,
     15.8
    ],
    [
     "okuboESolar",
     0.4,
     0.5
    ],
    [
     "okuboESolar",
     2.9,
     9.6
    ],
    [
     "okuboEGarden",
     3,
     7.6
    ],
    [
     "okuboEJars",
     2.5,
     18.3
    ],
    [
     "okuboEGarden",
     2.4,
     14.4
    ],
    [
     "tank",
     3.7,
     1.2
    ],
    [
     "vent",
     3.9,
     12.9
    ],
    [
     "ac",
     1,
     13.2
    ],
    [
     "ac",
     4,
     5.8
    ],
    [
     "vent",
     3.9,
     11.4
    ],
    [
     "okuboEJars",
     0.6,
     7.8
    ],
    [
     "tank",
     2,
     5.8
    ],
    [
     "okuboESolar",
     1.1,
     4.3
    ],
    [
     "ac",
     0.6,
     9
    ],
    [
     "ac",
     1.7,
     1.9
    ],
    [
     "tank",
     1.2,
     10.1
    ],
    [
     "ac",
     3.9,
     15.7
    ],
    [
     "tank",
     4.3,
     3.1
    ]
   ]
  },
  {
   "id": "e3",
   "x": 250,
   "y": 40,
   "w": 6,
   "h": 20,
   "face": 0,
   "kind": "okuboEFlats",
   "roof": "okuboEPaint",
   "props": [
    [
     "okuboEGarden",
     1.9,
     17.4
    ],
    [
     "tank",
     1.2,
     14.4
    ],
    [
     "okuboEWash",
     0.6,
     1.3
    ],
    [
     "okuboEWash",
     3.5,
     9.6
    ],
    [
     "hut",
     3.1,
     2.2
    ],
    [
     "okuboEGarden",
     0.4,
     7.9
    ],
    [
     "okuboESolar",
     3.3,
     4.3
    ],
    [
     "vent",
     3.3,
     11.8
    ],
    [
     "ac",
     0.4,
     9.3
    ],
    [
     "okuboEGarden",
     3.6,
     16.4
    ],
    [
     "vent",
     2.2,
     12.8
    ],
    [
     "ac",
     1.4,
     6.6
    ],
    [
     "tank",
     0.9,
     10.9
    ],
    [
     "okuboEWash",
     3,
     13.7
    ],
    [
     "hut",
     1.1,
     4
    ],
    [
     "okuboEGarden",
     3.6,
     0.7
    ],
    [
     "vent",
     4.1,
     6.4
    ],
    [
     "hut",
     4.3,
     10.8
    ],
    [
     "vent",
     4.6,
     15.3
    ],
    [
     "hut",
     3.1,
     7.5
    ],
    [
     "vent",
     2.2,
     9.3
    ],
    [
     "vent",
     4.4,
     17.7
    ]
   ]
  },
  {
   "id": "e4",
   "x": 250,
   "y": 60,
   "w": 6,
   "h": 20,
   "face": 0,
   "kind": "okuboEFlats",
   "roof": "tar",
   "props": [
    [
     "ac",
     0.8,
     14.5
    ],
    [
     "okuboEGarden",
     3.1,
     3.7
    ],
    [
     "hut",
     3.5,
     12.8
    ],
    [
     "okuboEJars",
     1.5,
     9.5
    ],
    [
     "ac",
     2.8,
     18.7
    ],
    [
     "hut",
     3.8,
     8.2
    ],
    [
     "ac",
     3.7,
     16.2
    ],
    [
     "okuboEWash",
     2.5,
     2.6
    ],
    [
     "okuboESolar",
     0.5,
     18.2
    ],
    [
     "okuboEWash",
     1.4,
     11.7
    ],
    [
     "vent",
     0.9,
     2.6
    ],
    [
     "vent",
     3,
     6.8
    ],
    [
     "tank",
     0.7,
     4.4
    ],
    [
     "okuboEWash",
     1.1,
     0.6
    ],
    [
     "ac",
     2.4,
     5.2
    ],
    [
     "vent",
     4.6,
     7.5
    ],
    [
     "ac",
     4.7,
     14.5
    ],
    [
     "okuboEJars",
     2.7,
     10.7
    ],
    [
     "okuboEWash",
     1,
     16.9
    ],
    [
     "tank",
     2,
     13.6
    ],
    [
     "vent",
     1.5,
     16
    ],
    [
     "okuboEWash",
     0.6,
     7.2
    ]
   ]
  },
  {
   "id": "e5",
   "x": 250,
   "y": 80,
   "w": 6,
   "h": 4,
   "face": 2,
   "kind": "okuboEFlats",
   "roof": "okuboEPaint",
   "props": [
    [
     "vent",
     1.5,
     0.7
    ],
    [
     "okuboEJars",
     3.3,
     1
    ],
    [
     "okuboEJars",
     1,
     1.9
    ]
   ]
  },
  {
   "id": "e5s",
   "x": 250,
   "y": 87,
   "w": 6,
   "h": 9,
   "face": 2,
   "kind": "okuboEFlats",
   "roof": "okuboEPaint",
   "props": [
    [
     "okuboEWash",
     2.2,
     2
    ],
    [
     "hut",
     3.4,
     3.4
    ],
    [
     "ac",
     0.5,
     4.4
    ],
    [
     "okuboEGarden",
     3.5,
     0.1
    ],
    [
     "vent",
     1.2,
     1.9
    ],
    [
     "tank",
     3.4,
     5.2
    ]
   ]
  },
  {
   "id": "a1",
   "x": 206,
   "y": 12,
   "w": 9,
   "h": 16,
   "face": 3,
   "kind": "okuboEFlats",
   "roof": "okuboEPaint",
   "props": [
    [
     "vent",
     4.7,
     10
    ],
    [
     "okuboEJars",
     1.1,
     4.2
    ],
    [
     "okuboEJars",
     1.2,
     3.1
    ],
    [
     "okuboEWash",
     5,
     2.8
    ],
    [
     "vent",
     7.2,
     5.6
    ],
    [
     "vent",
     5.8,
     4
    ],
    [
     "okuboEWash",
     3.1,
     7.1
    ],
    [
     "okuboEWash",
     1.8,
     11.5
    ],
    [
     "ac",
     1,
     7.3
    ],
    [
     "okuboEWash",
     5,
     10.7
    ],
    [
     "ac",
     2.7,
     9.7
    ],
    [
     "ac",
     6.8,
     9.7
    ],
    [
     "tank",
     3.7,
     0.5
    ],
    [
     "hut",
     0.8,
     0.7
    ],
    [
     "ac",
     3.9,
     5.4
    ],
    [
     "okuboEWash",
     4.1,
     8.7
    ],
    [
     "ac",
     7.6,
     1.2
    ],
    [
     "okuboEJars",
     5.8,
     7.2
    ],
    [
     "vent",
     2.2,
     8.4
    ],
    [
     "ac",
     7.5,
     3.9
    ],
    [
     "vent",
     5,
     0.4
    ]
   ]
  },
  {
   "id": "a2",
   "x": 215,
   "y": 12,
   "w": 8,
   "h": 16,
   "face": 3,
   "kind": "okuboEGrocer",
   "roof": "tar",
   "props": [
    [
     "skylight",
     5.7,
     7.8
    ],
    [
     "hut",
     0.5,
     5.5
    ],
    [
     "ac",
     0.5,
     10.2
    ],
    [
     "tank",
     4.3,
     3.8
    ],
    [
     "ac",
     2.4,
     6.1
    ],
    [
     "dish",
     1.2,
     2.9
    ],
    [
     "ac",
     4.4,
     7.5
    ],
    [
     "vent",
     3.2,
     2.5
    ],
    [
     "vent",
     2.8,
     9.3
    ],
    [
     "dish",
     6.7,
     6.9
    ],
    [
     "ac",
     4.1,
     6.4
    ],
    [
     "ac",
     6.3,
     0.8
    ],
    [
     "okuboEJars",
     4.7,
     1.8
    ],
    [
     "vent",
     2.4,
     3.9
    ],
    [
     "ac",
     0.9,
     0.4
    ]
   ]
  },
  {
   "id": "b1",
   "x": 225,
   "y": 12,
   "w": 9,
   "h": 16,
   "face": 3,
   "kind": "hotel",
   "roof": "concrete",
   "sign": {
    "text": "ホテル",
    "color": "pink"
   },
   "props": [
    [
     "dish",
     3.8,
     6.2
    ],
    [
     "hut",
     6,
     3.3
    ],
    [
     "tank",
     6.8,
     9.5
    ],
    [
     "ac",
     3.5,
     4.6
    ],
    [
     "dish",
     6.3,
     5.1
    ],
    [
     "ac",
     1.4,
     6.7
    ],
    [
     "ac",
     1.9,
     8.1
    ],
    [
     "okuboEJars",
     5,
     11.8
    ],
    [
     "tank",
     4.9,
     8.5
    ],
    [
     "ac",
     7.3,
     7.2
    ],
    [
     "tank",
     5.1,
     6.7
    ],
    [
     "vent",
     4.3,
     1.3
    ],
    [
     "dish",
     7.4,
     0.9
    ],
    [
     "tank",
     1.3,
     10.7
    ],
    [
     "skylight",
     2.8,
     9.8
    ],
    [
     "hut",
     2.3,
     0.4
    ],
    [
     "hut",
     3.3,
     7.9
    ]
   ]
  },
  {
   "id": "b2",
   "x": 234,
   "y": 12,
   "w": 8,
   "h": 10,
   "face": 3,
   "kind": "okuboEFlats",
   "roof": "ribbed",
   "props": [
    [
     "okuboESolar",
     3.7,
     0.8
    ],
    [
     "vent",
     1.4,
     5.9
    ],
    [
     "okuboEWash",
     1.2,
     2.9
    ],
    [
     "okuboEWash",
     0.5,
     4.2
    ],
    [
     "vent",
     6.9,
     4.7
    ],
    [
     "ac",
     3.3,
     5.6
    ],
    [
     "okuboEJars",
     5.1,
     5.8
    ],
    [
     "okuboEGarden",
     4.7,
     2.2
    ],
    [
     "ac",
     0.8,
     6.2
    ],
    [
     "okuboEWash",
     4.2,
     4.3
    ],
    [
     "okuboEGarden",
     5,
     3.3
    ]
   ]
  },
  {
   "id": "b2s",
   "x": 234,
   "y": 22,
   "w": 4,
   "h": 6,
   "face": 3,
   "kind": "okuboEFlats",
   "roof": "ribbed"
  },
  {
   "id": "c1",
   "x": 206,
   "y": 36,
   "w": 14,
   "h": 8,
   "face": 3,
   "kind": "okuboEBbq",
   "roof": "concrete",
   "sign": {
    "text": "ヤキトリ",
    "color": "amber"
   },
   "props": [
    [
     "tank",
     0.8,
     2.4
    ],
    [
     "ac",
     3.5,
     3.1
    ],
    [
     "vent",
     3.3,
     1.2
    ],
    [
     "tank",
     9.5,
     2.2
    ],
    [
     "dish",
     11.4,
     2.1
    ],
    [
     "dish",
     9.5,
     3.9
    ],
    [
     "skylight",
     4.3,
     1.9
    ],
    [
     "skylight",
     5.9,
     1.7
    ],
    [
     "vent",
     2,
     1.5
    ],
    [
     "dish",
     6.7,
     3.3
    ]
   ]
  },
  {
   "id": "d1",
   "x": 221,
   "y": 36,
   "w": 8,
   "h": 8,
   "face": 3,
   "kind": "ramen",
   "roof": "tar",
   "sign": {
    "text": "ラーメン",
    "color": "amber"
   },
   "props": [
    [
     "skylight",
     1.5,
     2.8
    ],
    [
     "skylight",
     2.8,
     3.3
    ],
    [
     "skylight",
     6.1,
     0.6
    ],
    [
     "okuboEJars",
     3.4,
     1.6
    ],
    [
     "dish",
     4.8,
     3.5
    ],
    [
     "okuboEJars",
     0.8,
     1.6
    ]
   ]
  },
  {
   "id": "d2",
   "x": 229,
   "y": 36,
   "w": 13,
   "h": 8,
   "face": 3,
   "kind": "okuboEFlats",
   "roof": "okuboEPaint",
   "props": [
    [
     "okuboESolar",
     8.1,
     2.8
    ],
    [
     "okuboEJars",
     5.8,
     3.2
    ],
    [
     "okuboEWash",
     9.5,
     0.5
    ],
    [
     "ac",
     10.8,
     2.2
    ],
    [
     "okuboEWash",
     1.2,
     0.7
    ],
    [
     "okuboEWash",
     4.2,
     1.6
    ],
    [
     "ac",
     2.8,
     3.6
    ],
    [
     "ac",
     7.6,
     0.7
    ],
    [
     "okuboEWash",
     3.7,
     0.4
    ],
    [
     "tank",
     11,
     3.4
    ],
    [
     "vent",
     1.1,
     2.9
    ],
    [
     "vent",
     4.2,
     3.6
    ]
   ]
  },
  {
   "id": "f1",
   "x": 206,
   "y": 46,
   "w": 12,
   "h": 8,
   "face": 3,
   "kind": "karaoke",
   "roof": "tar",
   "sign": {
    "text": "カラオケ",
    "color": "cyan"
   },
   "props": [
    [
     "ac",
     3.4,
     3.2
    ],
    [
     "dish",
     8.5,
     2.9
    ],
    [
     "dish",
     10.9,
     3.3
    ],
    [
     "vent",
     1.7,
     3.9
    ],
    [
     "ac",
     1.7,
     2.6
    ],
    [
     "vent",
     5.7,
     1.5
    ],
    [
     "dish",
     0.6,
     2.7
    ],
    [
     "dish",
     6.3,
     0.6
    ],
    [
     "ac",
     7.2,
     3.5
    ]
   ]
  },
  {
   "id": "f2",
   "x": 218,
   "y": 46,
   "w": 12,
   "h": 8,
   "face": 3,
   "kind": "okuboEFlats",
   "roof": "okuboEPaint",
   "props": [
    [
     "okuboEWash",
     5.2,
     1.6
    ],
    [
     "vent",
     1.8,
     3.6
    ],
    [
     "ac",
     3.1,
     3.9
    ],
    [
     "okuboESolar",
     8,
     2.5
    ],
    [
     "okuboESolar",
     10.2,
     2.7
    ],
    [
     "okuboEWash",
     4,
     2.7
    ],
    [
     "okuboEGarden",
     9.1,
     0.5
    ],
    [
     "okuboESolar",
     1.8,
     2.1
    ],
    [
     "okuboEWash",
     2.6,
     0.9
    ],
    [
     "vent",
     8.4,
     4.1
    ],
    [
     "ac",
     1.3,
     1.1
    ]
   ]
  },
  {
   "id": "f3",
   "x": 230,
   "y": 46,
   "w": 12,
   "h": 8,
   "face": 3,
   "kind": "bar",
   "roof": "concrete",
   "sign": {
    "text": "バー",
    "color": "pink"
   },
   "props": [
    [
     "ac",
     6.2,
     2
    ],
    [
     "ac",
     10.6,
     0.8
    ],
    [
     "vent",
     5.1,
     2.4
    ],
    [
     "okuboEJars",
     7.6,
     2.5
    ],
    [
     "skylight",
     4.8,
     0.6
    ],
    [
     "tank",
     3.2,
     2.3
    ],
    [
     "tank",
     1.7,
     2.4
    ],
    [
     "ac",
     10.3,
     2.6
    ],
    [
     "dish",
     2.2,
     4
    ]
   ]
  },
  {
   "id": "g1",
   "x": 206,
   "y": 62,
   "w": 8,
   "h": 8,
   "face": 3,
   "kind": "izakaya",
   "roof": "tile",
   "sign": {
    "text": "ヤキトリ",
    "color": "amber"
   },
   "props": [
    [
     "tank",
     5.8,
     1.9
    ],
    [
     "tank",
     1.2,
     3
    ],
    [
     "vent",
     2.8,
     1.5
    ],
    [
     "ac",
     0.7,
     1.4
    ],
    [
     "skylight",
     4.4,
     3.8
    ],
    [
     "tank",
     3.6,
     0.7
    ]
   ]
  },
  {
   "id": "g2",
   "x": 230,
   "y": 62,
   "w": 2,
   "h": 8,
   "face": 3,
   "kind": "okuboETyre",
   "roof": "okuboEPaint",
   "props": [
    [
     "vent",
     0.6,
     0.6
    ],
    [
     "ac",
     1,
     2.4
    ]
   ]
  },
  {
   "id": "g3",
   "x": 232,
   "y": 62,
   "w": 10,
   "h": 8,
   "face": 3,
   "kind": "okuboEGrocer",
   "roof": "concrete",
   "props": [
    [
     "tank",
     8.1,
     2.1
    ],
    [
     "hut",
     1.1,
     1.7
    ],
    [
     "vent",
     2.7,
     3.3
    ],
    [
     "hut",
     3.5,
     2.2
    ],
    [
     "ac",
     6,
     1.9
    ],
    [
     "skylight",
     7.6,
     0.7
    ],
    [
     "ac",
     3.6,
     0.4
    ]
   ]
  },
  {
   "id": "h1",
   "x": 206,
   "y": 72,
   "w": 12,
   "h": 10,
   "face": 3,
   "kind": "okuboEFlats",
   "roof": "okuboEPaint",
   "props": [
    [
     "okuboEWash",
     4.5,
     5.6
    ],
    [
     "okuboEJars",
     1.6,
     1
    ],
    [
     "vent",
     5.7,
     4.1
    ],
    [
     "ac",
     1.1,
     4.3
    ],
    [
     "okuboEGarden",
     5.3,
     1.2
    ],
    [
     "okuboEWash",
     7.6,
     1.6
    ],
    [
     "ac",
     5.4,
     2.9
    ],
    [
     "vent",
     8.1,
     5.9
    ],
    [
     "ac",
     1.3,
     2.3
    ],
    [
     "okuboESolar",
     9.8,
     3.5
    ],
    [
     "vent",
     2.9,
     2.7
    ],
    [
     "okuboEWash",
     9.3,
     5.6
    ],
    [
     "okuboEGarden",
     7.3,
     2.9
    ],
    [
     "vent",
     4.5,
     0.7
    ],
    [
     "okuboESolar",
     10.1,
     1.5
    ]
   ]
  },
  {
   "id": "h2",
   "x": 218,
   "y": 72,
   "w": 8,
   "h": 10,
   "face": 3,
   "kind": "shutter",
   "roof": "ribbed",
   "props": [
    [
     "hut",
     5,
     3
    ],
    [
     "dish",
     5.4,
     4.5
    ],
    [
     "ac",
     6.5,
     5.4
    ],
    [
     "tank",
     2.3,
     5.3
    ],
    [
     "dish",
     5.3,
     1.9
    ],
    [
     "ac",
     4.7,
     0.4
    ],
    [
     "dish",
     3.6,
     3.5
    ],
    [
     "ac",
     1,
     0.5
    ]
   ]
  },
  {
   "id": "h3",
   "x": 226,
   "y": 72,
   "w": 8,
   "h": 10,
   "face": 3,
   "kind": "konbini",
   "roof": "concrete",
   "props": [
    [
     "ac",
     5.3,
     4.9
    ],
    [
     "skylight",
     2.8,
     2.6
    ],
    [
     "dish",
     6.9,
     3.6
    ],
    [
     "ac",
     1,
     1.8
    ],
    [
     "vent",
     0.7,
     3.1
    ],
    [
     "ac",
     4.9,
     0.7
    ],
    [
     "tank",
     2.5,
     0.8
    ],
    [
     "tank",
     1.5,
     3.8
    ]
   ]
  },
  {
   "id": "h4",
   "x": 234,
   "y": 72,
   "w": 8,
   "h": 10,
   "face": 3,
   "kind": "office",
   "roof": "tar",
   "props": [
    [
     "ac",
     4.4,
     4.6
    ],
    [
     "ac",
     1.1,
     1.8
    ],
    [
     "vent",
     5.7,
     3.9
    ],
    [
     "tank",
     2.6,
     1.4
    ],
    [
     "tank",
     5.9,
     1.5
    ],
    [
     "dish",
     2.8,
     3.4
    ],
    [
     "hut",
     0.7,
     3.2
    ],
    [
     "ac",
     4.2,
     3.6
    ]
   ]
  },
  {
   "id": "i1",
   "x": 206,
   "y": 90,
   "w": 12,
   "h": 6,
   "face": 3,
   "kind": "okuboEBbq",
   "roof": "tar",
   "sign": {
    "text": "ヤキトリ",
    "color": "cyan"
   },
   "props": [
    [
     "ac",
     4.6,
     1.5
    ],
    [
     "ac",
     8.6,
     0.5
    ],
    [
     "skylight",
     6.6,
     0.9
    ],
    [
     "ac",
     1.3,
     1.8
    ],
    [
     "vent",
     4.9,
     0.4
    ]
   ]
  },
  {
   "id": "i2",
   "x": 218,
   "y": 90,
   "w": 12,
   "h": 6,
   "face": 3,
   "kind": "okuboEFlats",
   "roof": "okuboEPaint",
   "props": [
    [
     "vent",
     10.2,
     1.9
    ],
    [
     "okuboESolar",
     7.2,
     1.3
    ],
    [
     "vent",
     5.4,
     0.7
    ],
    [
     "okuboEJars",
     5,
     1.9
    ],
    [
     "okuboEWash",
     1.3,
     0.9
    ],
    [
     "okuboEJars",
     1.9,
     2
    ],
    [
     "vent",
     11.1,
     1.1
    ]
   ]
  },
  {
   "id": "i3",
   "x": 230,
   "y": 90,
   "w": 12,
   "h": 6,
   "face": 3,
   "kind": "okuboEGrocer",
   "roof": "ribbed",
   "props": [
    [
     "ac",
     1.8,
     1.8
    ],
    [
     "ac",
     7.3,
     1.9
    ],
    [
     "ac",
     7.4,
     0.5
    ],
    [
     "dish",
     5.9,
     0.9
    ],
    [
     "okuboEJars",
     8.8,
     1.4
    ]
   ]
  }
 ],
 "lamps": [
  [
   202.5,
   5.6,
   "s"
  ],
  [
   210.5,
   5.6,
   "s"
  ],
  [
   218.5,
   5.6,
   "s"
  ],
  [
   226.5,
   5.6,
   "s"
  ],
  [
   234.5,
   5.6,
   "s"
  ],
  [
   242.5,
   5.6,
   "s"
  ],
  [
   210,
   10.4,
   "n"
  ],
  [
   210,
   29.6,
   "s"
  ],
  [
   210,
   34.5,
   "n"
  ],
  [
   210,
   55.6,
   "s"
  ],
  [
   210,
   60.5,
   "n"
  ],
  [
   210,
   83.6,
   "s"
  ],
  [
   210,
   88.5,
   "n"
  ],
  [
   218,
   10.4,
   "n"
  ],
  [
   218,
   29.6,
   "s"
  ],
  [
   218,
   34.5,
   "n"
  ],
  [
   218,
   55.6,
   "s"
  ],
  [
   218,
   60.5,
   "n"
  ],
  [
   218,
   83.6,
   "s"
  ],
  [
   218,
   88.5,
   "n"
  ],
  [
   226,
   10.4,
   "n"
  ],
  [
   226,
   29.6,
   "s"
  ],
  [
   226,
   34.5,
   "n"
  ],
  [
   226,
   55.6,
   "s"
  ],
  [
   226,
   60.5,
   "n"
  ],
  [
   226,
   83.6,
   "s"
  ],
  [
   226,
   88.5,
   "n"
  ],
  [
   234,
   10.4,
   "n"
  ],
  [
   234,
   29.6,
   "s"
  ],
  [
   234,
   34.5,
   "n"
  ],
  [
   234,
   55.6,
   "s"
  ],
  [
   234,
   60.5,
   "n"
  ],
  [
   234,
   83.6,
   "s"
  ],
  [
   234,
   88.5,
   "n"
  ],
  [
   242,
   10.4,
   "n"
  ],
  [
   242,
   29.6,
   "s"
  ],
  [
   242,
   34.5,
   "n"
  ],
  [
   242,
   55.6,
   "s"
  ],
  [
   242,
   60.5,
   "n"
  ],
  [
   242,
   83.6,
   "s"
  ],
  [
   242,
   88.5,
   "n"
  ],
  [
   204.5,
   14,
   "w"
  ],
  [
   243.5,
   14,
   "e"
  ],
  [
   204.5,
   22,
   "w"
  ],
  [
   243.5,
   22,
   "e"
  ],
  [
   204.5,
   40,
   "w"
  ],
  [
   243.5,
   40,
   "e"
  ],
  [
   204.5,
   50,
   "w"
  ],
  [
   243.5,
   50,
   "e"
  ],
  [
   204.5,
   66,
   "w"
  ],
  [
   243.5,
   66,
   "e"
  ],
  [
   204.5,
   76,
   "w"
  ],
  [
   243.5,
   76,
   "e"
  ],
  [
   204.5,
   92,
   "w"
  ],
  [
   243.5,
   92,
   "e"
  ],
  [
   248.5,
   8,
   "w"
  ],
  [
   248.5,
   24,
   "w"
  ],
  [
   248.5,
   40,
   "w"
  ],
  [
   248.5,
   56,
   "w"
  ],
  [
   248.5,
   72,
   "w"
  ],
  [
   248.5,
   88,
   "w"
  ]
 ]
}
